<script setup>
import {onBeforeUnmount, onMounted, ref} from "vue";

const props = defineProps({
    errors: Array,
    audioUrl: String
})

const audioDuration = ref(0);
const audioObjectUrl = ref(null);

const audioFile = ref(null);

const audioInput = ref(null);

const emits = defineEmits(['onAudioChange', 'onAudioRemove', 'onAudioDurationChange'])

const loadExistingAudioDuration = () => {
    if (props.audioUrl && !audioFile.value) {
        const audio = new Audio(props.audioUrl);
        audio.addEventListener('loadedmetadata', () => {
            audioDuration.value = audio.duration || 0;
            emits('onAudioDurationChange', audioDuration.value);
        });
    }
}

const onAudioChange = (event) => {
    const file = event.target.files[0];

    if (audioObjectUrl.value) {
        URL.revokeObjectURL(audioObjectUrl.value);
        audioObjectUrl.value = null;
    }

    if (file) {
        audioFile.value = file;
        audioDuration.value = 0;

        const objectUrl = URL.createObjectURL(file);
        audioObjectUrl.value = objectUrl;

        const audio = new Audio(objectUrl);
        audio.addEventListener('loadedmetadata', () => {
            audioDuration.value = audio.duration || 0;
            emits('onAudioDurationChange', audioDuration.value);
        });
    } else {
        audioFile.value = null;
        audioDuration.value = 0;
    }
    emits('onAudioChange', file);
}

const removeAudio = () => {
    audioFile.value = null;
    if (audioObjectUrl.value) {
        URL.revokeObjectURL(audioObjectUrl.value);
        audioObjectUrl.value = null;
    }
    audioDuration.value = 0;
    if (audioInput.value) {
        audioInput.value.value = '';
    }
    emits('onAudioRemove')
}
onMounted(() => {
    loadExistingAudioDuration();
})

onBeforeUnmount(() => {
    if (audioObjectUrl.value) {
        URL.revokeObjectURL(audioObjectUrl.value);
    }
})
</script>

<template>
    <b-field :label="$t('file_upload.audio_file_label')" horizontal custom-class="mb-3"
             :type="errors ? 'is-danger' : null"
             :message="errors ? errors[0] : null">
        <div class="is-fullwidth">
            <div class="file has-name is-fullwidth mb-3">
                <label class="file-label">
                    <input ref="audioInput" class="file-input" type="file" accept="audio/*"
                           @change="onAudioChange">
                    <span class="file-cta">
                                <span class="file-icon"><i class="mdi mdi-music"></i></span>
                                <span class="file-label">{{ $t('file_upload.select_audio_file') }}...</span>
                            </span>
                    <span class="file-name" v-if="audioFile">{{ audioFile.name }}</span>
                    <span class="file-name" v-else>{{ $t('file_upload.no_selected_file') }}</span>
                </label>
            </div>

            <div v-if="audioUrl" class="box">
                <div class="is-flex is-justify-content-space-between is-align-items-center">
                    <audio controls :src="audioUrl" class="is-flex-grow-1 mr-3"></audio>
                    <button type="button" class="button is-danger is-light" @click="removeAudio">
                        <b-icon icon="delete" size="is-small"></b-icon>
                    </button>
                </div>
                <p class="is-size-7 mt-2" v-if="audioDuration > 0">
                    {{ $t('file_upload.audio_length') }}: <strong>{{ Math.floor(audioDuration) }}s</strong>
                </p>
            </div>
        </div>
    </b-field>
</template>
